export enum ButtonType {
    Accept,
    Cancel,
    Other
  }